import React from 'react';
import GrievanceSystem from './components/GrievanceSystem';

function App() {
  return (
    <div className="App">
      <GrievanceSystem />
    </div>
  );
}

export default App;
